var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { left: "" },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _vm.showTabParametrosSistema
            ? _c(
                "v-tab",
                { attrs: { href: "#tab-1", to: "/parametrosSistema" } },
                [_vm._v("Parámetros del Sistema")]
              )
            : _vm._e(),
          _c("v-tab", { attrs: { href: "#tab-2" } }, [
            _vm._v("Parámetros del Cliente")
          ]),
          _c("v-spacer"),
          _vm.accionEditar.visible
            ? _c(
                "v-btn",
                {
                  staticClass: "btn-grabar",
                  staticStyle: { "margin-right": "20px" },
                  attrs: {
                    disabled: _vm.botonGuardarEnabled,
                    left: "",
                    depressed: ""
                  },
                  on: {
                    click: function($event) {
                      _vm.dialogConfirmacion = true
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v("Guardar Cambios")
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs8: "", sm8: "", md8: "" } },
                    [_vm._v("Parámetro")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [_vm._v("Valor")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Refrescar la visualización del mapa cada")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled:
                            !_vm.refrescarVisualizacionMapaConfigurableCliente ||
                            !_vm.accionEditar.visible,
                          items: _vm.segundos,
                          "menu-props": "auto",
                          label: "Segundos"
                        },
                        model: {
                          value: _vm.refrescoVisualizacionMapaSegundos,
                          callback: function($$v) {
                            _vm.refrescoVisualizacionMapaSegundos = $$v
                          },
                          expression: "refrescoVisualizacionMapaSegundos"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Segundos")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Expiración de las variables de sesión")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled:
                            !_vm.expiracionVariablesSesionConfigurableCliente ||
                            !_vm.accionEditar.visible,
                          items: _vm.horasSesion,
                          "menu-props": "auto",
                          label: "Horas"
                        },
                        model: {
                          value: _vm.expiracionVariablesSesionHoras,
                          callback: function($$v) {
                            _vm.expiracionVariablesSesionHoras = $$v
                          },
                          expression: "expiracionVariablesSesionHoras"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de eliminación de las notificaciones")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled:
                            !_vm.eliminacionNotificacionesConfigurableCliente ||
                            !_vm.accionEditar.visible,
                          items: _vm.dias,
                          "menu-props": "auto",
                          label: "Días"
                        },
                        model: {
                          value: _vm.eliminacionNotificacionesDias,
                          callback: function($$v) {
                            _vm.eliminacionNotificacionesDias = $$v
                          },
                          expression: "eliminacionNotificacionesDias"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Días")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de eliminación de las alertas")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled:
                            !_vm.eliminacionAlertasConfigurableCliente ||
                            !_vm.accionEditar.visible,
                          items: _vm.horas,
                          "menu-props": "auto",
                          "no-data-text": "Sin resultados",
                          label: "Horas"
                        },
                        model: {
                          value: _vm.eliminacionAlertasHoras,
                          callback: function($$v) {
                            _vm.eliminacionAlertasHoras = $$v
                          },
                          expression: "eliminacionAlertasHoras"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo en que los equipos no están transmitiendo")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _vm.idUnidadTiempo === 1
                        ? _c("v-select", {
                            attrs: {
                              "no-data-text": "Sin resultados",
                              items: _vm.unidadTiempoSeleccionadaMinutos,
                              label: _vm.labelUnidadTiempoSeleccionada,
                              disabled:
                                !_vm.actualizacionEstadoConexionGpsConfigurableCliente ||
                                !_vm.accionEditar.visible
                            },
                            model: {
                              value: _vm.actualizacionEstadoConexionGps,
                              callback: function($$v) {
                                _vm.actualizacionEstadoConexionGps = $$v
                              },
                              expression: "actualizacionEstadoConexionGps"
                            }
                          })
                        : _vm._e(),
                      _vm.idUnidadTiempo === 2
                        ? _c("v-select", {
                            attrs: {
                              "no-data-text": "Sin resultados",
                              items: _vm.unidadTiempoSeleccionadaHoras,
                              label: _vm.labelUnidadTiempoSeleccionada,
                              disabled:
                                !_vm.actualizacionEstadoConexionGpsConfigurableCliente ||
                                !_vm.accionEditar.visible
                            },
                            model: {
                              value: _vm.actualizacionEstadoConexionGps,
                              callback: function($$v) {
                                _vm.actualizacionEstadoConexionGps = $$v
                              },
                              expression: "actualizacionEstadoConexionGps"
                            }
                          })
                        : _vm._e(),
                      _vm.idUnidadTiempo === 3
                        ? _c("v-select", {
                            attrs: {
                              "no-data-text": "Sin resultados",
                              items: _vm.unidadTiempoSeleccionadaDias,
                              label: _vm.labelUnidadTiempoSeleccionada,
                              disabled:
                                !_vm.actualizacionEstadoConexionGpsConfigurableCliente ||
                                !_vm.accionEditar.visible
                            },
                            model: {
                              value: _vm.actualizacionEstadoConexionGps,
                              callback: function($$v) {
                                _vm.actualizacionEstadoConexionGps = $$v
                              },
                              expression: "actualizacionEstadoConexionGps"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": "auto",
                          items: _vm.unidadTiempo,
                          label: _vm.labelUnidadTiempoSeleccionada,
                          disabled:
                            !_vm.actualizacionEstadoConexionGpsConfigurableCliente ||
                            !_vm.accionEditar.visible
                        },
                        on: {
                          change: function($event) {
                            return _vm.MostrarSelect()
                          }
                        },
                        model: {
                          value: _vm.labelUnidadTiempoSeleccionada,
                          callback: function($$v) {
                            _vm.labelUnidadTiempoSeleccionada = $$v
                          },
                          expression: "labelUnidadTiempoSeleccionada"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de Visualización de las Notificaciones")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled: !_vm.accionEditar.visible,
                          items: _vm.horasNotificaciones,
                          "menu-props": "auto",
                          "no-data-text": "Sin resultados",
                          label: "Horas"
                        },
                        model: {
                          value: _vm.tiempoVisualizacionNotificaciones,
                          callback: function($$v) {
                            _vm.tiempoVisualizacionNotificaciones = $$v
                          },
                          expression: "tiempoVisualizacionNotificaciones"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de Descanso en 24 Horas")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled: !_vm.accionEditar.visible,
                          items: _vm.horasDescanso,
                          "menu-props": "auto",
                          "no-data-text": "Sin resultados",
                          label: "Horas"
                        },
                        model: {
                          value: _vm.tiempoDescanso,
                          callback: function($$v) {
                            _vm.tiempoDescanso = $$v
                          },
                          expression: "tiempoDescanso"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v('Tiempo de Descanso cada "N" cantidad de horas')]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _vm.idUnidadTiempoDescanso === 0
                        ? _c("v-select", {
                            attrs: {
                              "no-data-text": "Sin resultados",
                              items:
                                _vm.unidadTiempoSeleccionadaMinutosDescanso,
                              label: _vm.labelUnidadTiempoSeleccionadaDescanso
                            },
                            model: {
                              value: _vm.tiempoDescansoCada,
                              callback: function($$v) {
                                _vm.tiempoDescansoCada = $$v
                              },
                              expression: "tiempoDescansoCada"
                            }
                          })
                        : _vm._e(),
                      _vm.idUnidadTiempoDescanso === 1
                        ? _c("v-select", {
                            attrs: {
                              "no-data-text": "Sin resultados",
                              items: _vm.unidadTiempoSeleccionadaHorasDescanso,
                              label: _vm.labelUnidadTiempoSeleccionadaDescanso
                            },
                            model: {
                              value: _vm.tiempoDescansoCada,
                              callback: function($$v) {
                                _vm.tiempoDescansoCada = $$v
                              },
                              expression: "tiempoDescansoCada"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": "auto",
                          items: _vm.unidadTiempoDescanso,
                          label: _vm.labelUnidadTiempoSeleccionadaDescanso
                        },
                        on: {
                          change: function($event) {
                            return _vm.handleChangeUnidadTiempoDescanso()
                          }
                        },
                        model: {
                          value: _vm.labelUnidadTiempoSeleccionadaDescanso,
                          callback: function($$v) {
                            _vm.labelUnidadTiempoSeleccionadaDescanso = $$v
                          },
                          expression: "labelUnidadTiempoSeleccionadaDescanso"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Cantidad de")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled: !_vm.accionEditar.visible,
                          items: _vm.cadaHorasDescanso,
                          "menu-props": "auto",
                          "no-data-text": "Sin resultados",
                          label: "Horas"
                        },
                        model: {
                          value: _vm.cadaTiempoDescanso,
                          callback: function($$v) {
                            _vm.cadaTiempoDescanso = $$v
                          },
                          expression: "cadaTiempoDescanso"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de visualización en la campana")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.horasCampana,
                          "menu-props": "auto",
                          disabled:
                            !_vm.tiempoVisualizacionCampanaConfigurableCliente ||
                            !_vm.accionEditar.visible,
                          label: "Horas"
                        },
                        model: {
                          value: _vm.tiempoVisualizacionCampana,
                          callback: function($$v) {
                            _vm.tiempoVisualizacionCampana = $$v
                          },
                          expression: "tiempoVisualizacionCampana"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de visualización en el popup")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.segundosPopUp,
                          "menu-props": "auto",
                          disabled:
                            !_vm.tiempoVisualizacionPopupConfigurableCliente ||
                            !_vm.accionEditar.visible,
                          label: "Segundos"
                        },
                        model: {
                          value: _vm.tiempoVisualizacionPopup,
                          callback: function($$v) {
                            _vm.tiempoVisualizacionPopup = $$v
                          },
                          expression: "tiempoVisualizacionPopup"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Segundos")]
                  )
                ],
                1
              ),
              _c("v-divider")
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: "Editar Parámetros del Cliente",
          mensaje: "¿Está seguro que desea guardar los cambios realizados?",
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.guardarCambios($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }